import {Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {MatTooltip} from '@angular/material/tooltip';

@Directive({
  selector: '[appTruncateWithTooltip]',
})
export class TruncateWithTooltipDirective implements OnInit {

  @Input() allowedTextLength = 25;
  @Input() tooltipText = '';
  @Input() matTip: MatTooltip;

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.truncateText(this.tooltipText);
  }

  truncateText(name: string, maxLength = this.allowedTextLength): void {
    const ext: string = name.substring(name.lastIndexOf('.') + 1, name.length).toLowerCase();
    let newName: string = name.replace('.' + ext, '');

    if (name.length < maxLength) {
      this.elementRef.nativeElement.innerText = name.replace(/'/g, '');
    } else {
      newName = newName.substring(0, maxLength) + (name.length >= maxLength ? '...' : '');
      this.matTip.message = name;
      const temp: string = newName + '.' + ext;
      this.elementRef.nativeElement.innerText = temp.replace(/'/g, '');
    }
  }

}
